import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const eventCards = [
  {
    title: 'İstanbul – Bu Hafta Konserler',
    city: 'istanbul',
    description: 'Şehrin ritmini yakalayın.'
  },
  {
    title: 'Ankara – Açık Doğa Alanları',
    city: 'ankara',
    description: 'Başkentin yeşil kaçış noktaları.'
  },
  {
    title: 'Antalya – Hafta Sonu Etkinlikleri',
    city: 'antalya',
    description: 'Güneşin ve eğlencenin tadını çıkarın.'
  },
    {
    title: 'İzmir – Tarihi Yerler',
    city: 'izmir',
    description: 'Ege\'nin incisindeki antik hazineler.'
  }
];

const CurrentEvents = () => {
  return (
    <section className="bg-gray-50 dark:bg-gray-800 py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white">
            Şu an nerede ne oluyor?
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            81 ilde etkinlikleri, doğa güzelliklerini ve kapalı mekânları tek ekranda takip et.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {eventCards.map((card, index) => (
            <Link 
              to={`/blog?city=${card.city}`} 
              key={index} 
              className="block bg-white dark:bg-gray-700 rounded-lg shadow-md p-6 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
            >
              <h3 className="font-bold text-lg text-gray-900 dark:text-white">{card.title}</h3>
              <p className="text-gray-600 dark:text-gray-400 mt-2 text-sm">{card.description}</p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/blog" className="inline-flex items-center text-blue-600 dark:text-blue-400 font-semibold hover:underline">
            Tüm 81 ili gör <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CurrentEvents;
